import { connect } from 'react-redux';
import { isLoaded } from 'react-redux-firebase';
import { Divider, Grid, Header, Image, Item, Segment } from 'semantic-ui-react';
import { authorization } from '../../../app/common/util/authorization';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import WikiNav from '../WikiNav';
import { WikiSearchProvider } from '../WikiSearchContext';
import BhpGuide from './BhpGuide';
import ParentGuardianGuide from './ParentGuardianGuide';
import PmGuide from './PmGuide';

const sessionImageStyle = {
  filter: 'brightness(100%)',
};

const sessionImageTextStyle = {
  position: 'absolute',
  bottom: '5%',
  left: '1%',
  width: '100%',
  height: 'auto',
  color: 'white',
};

const mapState = (state) => ({
  profile: state.firebase.profile,
});

const Guides = ({ hasRole, profile }) => {
  hasRole = (role) => {
    return authorization.hasRole(role, profile);
  };

  if (!isLoaded(profile)) return <LoadingComponent />;

  return (
    <WikiSearchProvider>
      <Grid id="detailed-segment">
        <Grid.Column width={16}>
          {hasRole(['pc', 'admin', 'pm', 'auditor']) && (
            <Segment.Group>
              <Segment
                basic
                attached="top"
                style={{ padding: '0' }}
                id="segment"
              >
                <Image
                  src={`/assets/categoryImages/PinkHeader.svg`}
                  id="header-image"
                  fluid
                  style={sessionImageStyle}
                />
                <Segment basic style={sessionImageTextStyle}>
                  <Item.Group>
                    <Item>
                      <Item.Content>
                        <Header size="huge" id="wiki-header">
                          Guides
                        </Header>
                      </Item.Content>
                    </Item>
                  </Item.Group>
                </Segment>
              </Segment>

              <Segment id="segment">
                <WikiNav />
                <Grid verticalAlign="middle">
                  <Grid.Column width={16} id="dg">
                    <Header as="h3" id="pink" to="/bhpGuide">
                      BHP Guide
                    </Header>
                    <BhpGuide />
                    <Header as="h3" id="pink">
                      PM Guide
                    </Header>
                    <PmGuide />
                    <Header as="h3" id="pink">
                      Parent/Guardian Guide
                    </Header>
                    <ParentGuardianGuide />
                  </Grid.Column>
                </Grid>
              </Segment>
            </Segment.Group>
          )}

          {hasRole(['bhp']) && (
            <Segment.Group>
              <Segment
                basic
                attached="top"
                style={{ padding: '0' }}
                id="segment"
              >
                <Image
                  src={`/assets/categoryImages/PinkHeader.svg`}
                  id="header-image"
                  fluid
                  style={sessionImageStyle}
                />
                <Segment basic style={sessionImageTextStyle}>
                  <Item.Group>
                    <Item>
                      <Item.Content>
                        <Header size="huge" id="wiki-header">
                          Guides
                        </Header>
                      </Item.Content>
                    </Item>
                  </Item.Group>
                </Segment>
              </Segment>

              <Segment id="segment">
                <WikiNav />
                <Divider />
                <Grid verticalAlign="middle">
                  <Grid.Column width={16} id="dg">
                    <Header as="h3" id="pink">
                      BHP Guide
                    </Header>
                    <BhpGuide />
                  </Grid.Column>
                </Grid>
              </Segment>
            </Segment.Group>
          )}

          {hasRole(['client']) && (
            <Segment.Group>
              <Segment
                basic
                attached="top"
                style={{ padding: '0' }}
                id="segment"
              >
                <Image
                  src={`/assets/categoryImages/PinkHeader.svg`}
                  id="header-image"
                  fluid
                  style={sessionImageStyle}
                />
                <Segment basic style={sessionImageTextStyle}>
                  <Item.Group>
                    <Item>
                      <Item.Content>
                        <Header size="huge" id="wiki-header">
                          Parent/Guardian Guide
                        </Header>
                      </Item.Content>
                    </Item>
                  </Item.Group>
                </Segment>
              </Segment>

              <Segment id="segment">
                <WikiNav />
                <Divider />
                <Grid verticalAlign="middle">
                  <Grid.Column width={16} id="dg">
                    <Header as="h3" id="pink">
                      Parent/Guardian Guide
                    </Header>
                    <ParentGuardianGuide />
                  </Grid.Column>
                </Grid>
              </Segment>
            </Segment.Group>
          )}
        </Grid.Column>
      </Grid>
    </WikiSearchProvider>
  );
};

export default connect(mapState)(Guides);
